/* eslint-disable @angular-eslint/prefer-standalone */
import { TypeOfPdf } from './../../enum/pdf-custom.enum';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { PoComboOption, PoModalAction, PoModalComponent } from '@po-ui/ng-components';
import { LiteralsWords } from "src/app/i18n/literals.model";
import { LiteralsService } from "../../services/literals-service";
import { PdfCustomService } from '../../services/pdf-custom/pdf-custom.service';
import { Observable, Subscriber } from 'rxjs';
import { MingleService } from '@totvs/mingle';
import { PdfCustomConfirmedData } from '../../interfaces/pdf-custom.model';

@Component({
  selector: 'tgv-pdf-custom-choice',
  standalone: false,
  templateUrl: './pdf-custom-choice.component.html'
})
export class PdfCustomChoiceComponent implements OnInit {
  @Input() dataPdfCustom: Array<PoComboOption>;
  @Output() confirmed: EventEmitter<PdfCustomConfirmedData> = new EventEmitter();
  @ViewChild('pdfCustomModal', { static: true }) pdfCustomModal: PoModalComponent;
  modalOptions: PoModalAction[];
  literals: LiteralsWords;
  selectedValue: string = "000000";

  constructor(
    private readonly literalsService: LiteralsService,
    private readonly pdfCustomService: PdfCustomService,
    private readonly mingleService: MingleService
  ) {
    this.literals = this.literalsService.getLiteralModule();
  }

  ngOnInit(): void {
    this.onInitModalOptions();
  }

  onInitModalOptions(): void {
    this.modalOptions = [
      {
        action: () => this.confirmPdfCustom(),
        label: this.literals.str0123
      },
      {
        action: () => this.pdfCustomModal.close(),
        label: this.literals.str0034
      }
    ];
  }

  getPdfCustomValues(typeOfPdf: TypeOfPdf): Observable<PoComboOption[]> {
    return new Observable<PoComboOption[]>(observer => {
      const allItems: PoComboOption[] = [{
        value: "000000",
        label: this.literals.str0909
      }];

      const serverVersion = localStorage.getItem('serverVersion');

      if (this.compareVersions(serverVersion, '1.11.3') <= -1) {
        observer.next(allItems);
        observer.complete();
      } else {
        const page = 1;
        this.concatenatePage(observer, typeOfPdf, page, allItems);
      }
    });
  }

  concatenatePage(
    observer: Subscriber<PoComboOption[]>,
    typeOfPdf: TypeOfPdf,
    page: number,
    allItems: PoComboOption[]
  ): void {
    const pageSize = 10;

    this.pdfCustomService.getHeaderPdfCustom('', page, pageSize).subscribe({
      next: response => {
        const filteredItems = response.items
          .filter(item => item.type === typeOfPdf)
          .map(item => ({
            value: item.id,
            label: item.title
          }));

        allItems.push(...filteredItems);

        if (response.hasNext) {
          this.concatenatePage(observer, typeOfPdf, page + 1, allItems);
        } else {
          if (allItems.length === 0) {
            allItems.push({
              value: "000000",
              label: this.literals.str0909
            });
          }

          observer.next(allItems);
          observer.complete();
        }
      },
      error: () => {
        observer.next([{
          value: "000000",
          label: this.literals.str0909
        }]);
        observer.complete();
      }
    });
  }

  openPdfCustomOptions(): void {
    this.mingleService.registerMetric('PGV-PDF-CUSTOM');
    this.pdfCustomModal.open();
  }

  confirmPdfCustom(): void {
    this.confirmed.emit({ result: this.selectedValue });
    this.pdfCustomModal.close();
  }

  compareVersions(v1: string, v2: string): number {
    const v1Parts = v1.split('.').map(Number);
    const v2Parts = v2.split('.').map(Number);

    for (let i = 0; i < Math.max(v1Parts.length, v2Parts.length); i++) {
      const num1 = v1Parts[i] || 0;
      const num2 = v2Parts[i] || 0;

      if (num1 < num2) return -1;
      if (num1 > num2) return 1;
    }

    return 0;
  }
}
